/** Сколько последних матчей показывает лента. */
export const LATEST_MATCHES_LIMIT = 10;

/** Сколько секунд кэш ленты считается свежим при повторном заходе на главную. */
export const LATEST_MATCHES_FRESH_SECONDS = 300;
